<!--
// According to [Wikipedia](https://en.wikipedia.org/wiki/Respiratory_rate),
// the typical heart rate for a healthy adult ranges from 12-18 bpm,
// or 0.2-0.3 bps, or, if you prefer, 3.333-5 seconds per breath.

// I has opted to allow some extra wiggle room, thus a limit of 3-6 seconds
// per breath, and 0.16-0.33 breaths per second
-->

<script>
const spm = 60;
const mph = 60;
const hpd = 24;
const dpy = 365.25;

let spb = 4; // Seconds per Breath
$: bps = 1 / spb;
let spl = 3000000000; // Rounded down from an estimated 100-year lifespan "average". Averages are, of course, tricky over such a long period. Specially when non Homos walked 0rth during most of the time in question.

let breaths = 1;
let seconds = breaths * spb;
let minutes = seconds / 60;
let hours = minutes / 60;
let days = hours / 24;
let years = days / 365.25;
let lifetimes = seconds / spl;
let decimal = "";

function rnd(x, p = 2) {
  function format(y) {
    return parseFloat(Number(x).toFixed(p)).toLocaleString().replace(/\.([0-9])$/, ".$10");
  }

  if (p === 0) { // Basically, don't count partial breaths.
    return format(Math.floor(x));
  }
  return format(x);
}

function updateFromBreaths(brths) {
  breaths = brths;

  seconds = breaths * spb;

  minutes = seconds / spm;
  hours = minutes / mph;
  days = hours / hpd;
  years = days / dpy;
  lifetimes = seconds / spl;
}

function updateFromSeconds(secs) {
  seconds = secs;

  breaths = seconds / spb;

  minutes = seconds / spm;
  hours = minutes / mph;
  days = hours / hpd;
  years = days / dpy;
  lifetimes = seconds / spl;
}

function updateFromMinutes(mins) {
  minutes = mins;

  hours = minutes / mph;
  days = hours / hpd;

  seconds = minutes * spm;
  breaths = seconds / spb;
  years = days / dpy;
  lifetimes = seconds / spl;
}

function updateFromHours(hrs) {
  hours = hrs;

  minutes = hours * mph;
  seconds = minutes * spm;
  breaths = seconds / spb;

  days = hours / hpd;
  years = days / dpy;
  lifetimes = seconds / spl;
}

function updateFromDays(dys) {
  days = dys;

  hours = days * hpd;
  minutes = hours * mph;
  seconds = minutes * spm;
  breaths = seconds / spb;

  years = days / dpy;
  lifetimes = seconds / spl;
}

function updateFromYears(yrs) {
  years = yrs;

  days = years * dpy;
  hours = days * hpd;
  minutes = hours * mph;
  seconds = minutes * spm;
  breaths = seconds / spb;
  lifetimes = seconds / spl;
}

function updateFromLifetimes(lifes) {
  lifetimes = lifes;

  seconds = lifetimes * spl;
  breaths = seconds / spb;

  minutes = seconds / spm;
  hours = minutes / mph;
  days = hours / hpd;
  years = days / dpy;
}

function updateFromDecimal(d) {
  decimal = hexify(d);
}

function hexify(str) {
  console.log(typeof str);
  let foo = (+str).toString(16);
  console.log(foo);
  return foo;
}
</script>

<style>
dd {
  padding: 0.2rem 0 0.8rem 0;
}

.bignum {
  width: 80%;
}

.content {
  grid-area: content;
}

.header {
  grid-area: header;
}

.wrapper {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 50% 50%;
  grid-template-areas:
    "header content";
  background-color: #fff;
  color: #444;
  padding: 1rem;
  font-size: smaller;
}

@media (max-width: 850px) {
  .wrapper {
    grid-template-columns: 100%;
    grid-template-rows: 50% 50%;
    grid-template-areas:
      "header"
      "content";
  }
}

.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  padding: 20px;
  font-size: 150%;
}

.header {
  background-color: #999;
}
</style>

<!-- Thanks to https://codepen.io/rachelandrew/pen/oXKgoQ for helping me figure out the 2-col. grid layout. -->
<div class="wrapper">
  <div class="box header">
    <h1>Interactive</h1>
    <div>
      <label>Seconds per Breath
        <input
          type = "number"
          placeholder="️☠️"
          min = "3"
          max = "6"
          value={spb}
          on:input="{event => {spb = event.target.value; updateFromBreaths(breaths)}}"/>
      </label>
    </div>

    <div>
      <label>Breaths per Seconds
        <input
          type = "number"
          placeholder="️☠"
          min = "0.16"
          max = "0.33"
          value={bps}
          on:input="{event => {spb = 1 / event.target.value; updateFromBreaths(breaths) }}"/>
      </label>
    </div>

    <div>
      <label>Breaths
        <input
          class = "bignum"
          type = "number"
          placeholder="💨"
          min = "0"
          value={breaths}
          on:input="{event => updateFromBreaths(event.target.value)}"/>
      </label>
    </div>

    <div>
      <label>Seconds
        <input
          class = "bignum"
          type = "number"
          placeholder="⏲"
          min = "0"
          value={seconds}
          on:input="{event => updateFromSeconds(event.target.value)}"/>
      </label>
    </div>

    <div>
      <label>Minutes
        <input
          class = "bignum"
          type = "number"
          placeholder="🕥"
          min = "0"
          value={minutes}
          on:input="{event => updateFromMinutes(event.target.value)}"/>
      </label>
    </div>

    <div>
      <label>Hours
        <input
          class = "bignum"
          type = "number"
          placeholder="⏰"
          min = "0"
          value={hours}
          on:input="{event => updateFromHours(event.target.value)}"/>
      </label>
    </div>

    <div>
      <label>Days
        <input
          class = "bignum"
          type = "number"
          placeholder="🌏"
          min = "0"
          value={days}
          on:input="{event => updateFromDays(event.target.value)}"/>
      </label>
    </div>

    <div>
      <label>Years
        <input
          class = "bignum"
          type = "number"
          placeholder="🌞"
          min = "0"
          value={years}
          on:input="{event => updateFromYears(event.target.value)}"/>
      </label>
    </div>

    <div>
      <label>Lifetimes
        <input
          class = "bignum"
          type = "number"
          placeholder="🥚🍳"
          min = "0"
          value={lifetimes}
          on:input="{event => updateFromLifetimes(event.target.value)}"/>
      </label>
    </div>
  </div>

  <div class="box content">

    <h1>Rounded</h1>

    <dl>
      <dt>Seconds per Breath</dt>
      <dd>{rnd(spb)}</dd>
      <dt>Breaths per Second</dt>
      <dd>{rnd(bps)}</dd>
      <dt>Breaths</dt>
      <dd>{rnd(breaths, 0)}</dd>
      <dt>Seconds</dt>
      <dd>{rnd(seconds)}</dd>
      <dt>Minutes</dt>
      <dd>{rnd(minutes)}</dd>
      <dt>Hours</dt>
      <dd>{rnd(hours)}</dd>
      <dt>Days</dt>
      <dd>{rnd(days)}</dd>
      <dt>Years</dt>
      <dd>{rnd(years)}</dd>
      <dt>Lifetimes</dt>
      <dd>{rnd(lifetimes)}</dd>
    </dl>
  </div>
</div>

<div class="wrapper">
  <div class="box header">
    <h1>Decimal</h1>
    <label>
      Input
      <input
        class="bignum"
        type="number"
        placeholder="987654321O"
        on:input={event => updateFromDecimal(event.target.value)} />
    </label>
  </div>
  <div class="box content">
    <h1>Hexed</h1>
    <dl>
      <dt>Output</dt>
      <dd>{decimal}</dd>
    </dl>
  </div>
</div>
